<template>
  <div class="circles-bar">
    <div
      v-for="index in length"
      :key="index"
      class="circle"
      :style="{ backgroundColor: colors[index - 1], ...circleStyle }"
    />
    <div
      class="bar-label"
      :style="barLabelStyle"
    >
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'CirclesBar',
  props: {
    length: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    bold: {
      type: Boolean,
      default: false,
    },
    circleSize: {
      type: Number,
      default: 40,
    },
    labelMargin: {
      type: Number,
      default: 10,
    },
  },
  computed: {
    colors() {
      return [
        '#fbe9e7',
        '#ffccbc',
        '#ffab91',
        '#ff8a65',
        '#ff7043',
        '#f4511e',
      ];
    },
    barLabelStyle() {
      return {
        'font-weight': this.bold ? 'bold' : 'normal',
        'margin-bottom': `${this.labelMargin}px`,
      };
    },
    circleStyle() {
      return {
        width: `${this.circleSize}px`,
        height: `${this.circleSize}px`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.circles-bar {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  width: 200px // This is done in order to make sure that the labels take as much place as needed, the actual width will be lower than 200px
}

.circle {
  border-radius: 50%;
}

</style>
